import "flipping-pages/FlippingPages.css";
import React, { useState } from "react";
import FlippingPages from "flipping-pages";
import ArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import ArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import { css } from "emotion";

import styleConfig from "styles/styleConfig";

const { colors, boxShadow, transition, screens } = styleConfig;

const folderSrc = "/assets/folder-070220.jpg";

const folderStyle = css`
  display: flex;
  height: 800px;
  width: 632px;
  .folder-pages {
    height: 800px;
    width: 550px;
    perspective: 960px;
    -ms-user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    .page {
      color: white;
      height: 100%;
      background: url(${folderSrc});
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
    }
  }
  @media (max-width: ${screens.MOBILE_WIDTH}px) {
    height: 450px;
    width: 339px;
    .folder-pages {
      height: 450px;
      width: 257px;
    }
  }
  button {
    border: none;
    padding: 0 10px;
    color: ${colors.gray[100]};
    background-color: ${colors.gray[600]};
    opacity: 0.3;
    transition: ${transition.default};
    &:disabled {
      opacity: 0.3;
      background-color: ${colors.gray[400]};
      cursor: not-allowed;
    }
    &:focus {
      outline: none;
    }
    &:hover:not([disabled]) {
      opacity: 0.7;
      box-shadow: ${boxShadow.default};
      cursor: pointer;
    }
  }
`;

interface Props {}

const totalPages = 2;

const Folder: React.FC<Props> = () => {
  const [selected, setSelected] = useState<number>(0);

  const previous = () => setSelected(selected => selected - 1);
  const next = () => setSelected(selected => selected + 1);

  const handleSelectedChange = (selected: number) => setSelected(selected);

  return (
    <div className={folderStyle}>
      <button onClick={previous} disabled={!selected}>
        <ArrowLeftIcon />
      </button>
      <FlippingPages
        className="folder-pages"
        direction="horizontal"
        selected={selected}
        onSelectedChange={handleSelectedChange}
        touch-action="none"
      >
        <div className="page" />
        <div className="page" />
      </FlippingPages>
      {/* Buttons are required for keyboard navigation */}
      <button onClick={next} disabled={selected + 1 === totalPages}>
        <ArrowRightIcon />
      </button>
    </div>
  );
};

export default Folder;
